import { BRAND } from '@/config/brand.generated'

/**
 * #1421: sekme başlığının TEK kaynağı. Herkese açık sayfaların hazır HTML'i (src/prerender/entry.tsx) ve tarayıcıdaki
 * gezinme (document-title-observer) aynı metni kullanır; böylece bir sayfadan ötekine geçince eski başlık kalmaz.
 */
export const PUBLIC_PAGE_TITLES: Record<string, string> = {
  '/': `${BRAND.appName} — Amazon Seller Toolkit`,
  '/privacy': `Privacy Policy — ${BRAND.appName}`,
  '/about': `About — ${BRAND.appName}`,
  '/contact': `Contact — ${BRAND.appName}`,
  '/pricing': `Pricing — ${BRAND.appName}`,
  '/terms': `Terms of Service — ${BRAND.appName}`,
  '/login': `Sign in — ${BRAND.appName}`,
}
